import {
	AuthUserOutputDataOrganisationHeadcount,
	AuthUserOutputDataRecruitingVolume,
	RoleEnumKey,
} from '@jobilla/nexus-sdk'
import { createContext } from 'react'

export interface AuthUser {
	id: string
	email: string
	firstName: string | null
	lastName: string | null
	profilePictureUrl: string | null
	language: string | null
	firstLoginAt: string | null
	onboardingCompletedAt: string | null
	recruitingVolume: AuthUserOutputDataRecruitingVolume | null
	contactsCandidates: boolean | null
	managesTeam: boolean | null
	organisationHeadcount: AuthUserOutputDataOrganisationHeadcount | null
	phoneNumber: string | null
	isSelfSignup: boolean
	isProvisioned: boolean
}

export interface AuthState {
	user: AuthUser | null
	role: RoleEnumKey | null
	permissions: string[]
	isLoading: boolean
	isSignedIn: boolean
}

export interface AuthActions {
	signIn: (email: string, password: string) => Promise<void>
	signUp: (email: string, password: string, firstName: string, lastName: string) => Promise<void>
	verifyRegistration: (email: string, code: string, password: string) => Promise<void>
	signOut: () => Promise<void>
	getAccessToken: () => Promise<string | null>
	can: (permission: string) => boolean
	hasRole: (role: RoleEnumKey) => boolean
	refreshSession: () => Promise<void>
	fetchPermissions: () => Promise<void>
	switchOrganisation: (workosOrgId: string) => Promise<void>
}

export type AuthContextValue = AuthState & AuthActions

export const AuthContext = createContext<AuthContextValue | null>(null)
